import {IIconProps} from '../DataStoreIcon';

const OpenSearch = ({color, width = '24', height = '24'}: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_869_22414)">
        <path
          d="M23.1515 8.8125C22.6829 8.8125 22.3031 9.19237 22.3031 9.66097C22.3031 16.643 16.643 22.3031 9.66097 22.3031C9.19237 22.3031 8.8125 22.6829 8.8125 23.1515C8.8125 23.6201 9.19237 24 9.66097 24C17.5802 24 24 17.5802 24 9.66097C24 9.19237 23.6201 8.8125 23.1515 8.8125Z"
          fill={color}
        />
        <path
          d="M18.0305 14.25C18.8465 12.9189 19.6356 11.1442 19.4803 8.65954C19.1587 3.51272 14.4971 -0.391736 10.0952 0.0313998C8.372 0.197049 6.60256 1.6017 6.75976 4.11769C6.82808 5.21104 7.36321 5.85634 8.23291 6.35246C9.06068 6.8247 10.1242 7.12384 11.3298 7.46291C12.7861 7.87253 14.4753 8.33261 15.7737 9.28939C17.3297 10.4361 18.3934 11.7654 18.0305 14.25Z"
          fill={color}
        />
        <path
          d="M1.46948 5.25C0.653535 6.58106 -0.135565 8.35583 0.0196849 10.8405C0.341277 15.9873 5.00291 19.8917 9.40477 19.4686C11.128 19.3029 12.8974 17.8983 12.7402 15.3823C12.6719 14.289 12.1368 13.6437 11.2671 13.1475C10.4393 12.6753 9.37583 12.3762 8.1702 12.0371C6.71393 11.6275 5.02466 11.1674 3.72636 10.2106C2.1703 9.0639 1.1066 7.73464 1.46948 5.25Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_869_22414">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OpenSearch;
